import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { User } from '@app/models/User';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private _apiService:ApiService) { }

  private path: string = '/usuario';
  private pathCarnet : string = '/carnets';
  private pathCreate: string = '/accesoDatosUsuario/altaDatosUsuario';
  private pathUpdate: string = '/accesoDatosUsuario/modificarDatosUsuario';
  private pathUser: string = '/usuarioExiste/';
  private pathBaja: string = '/bajaUsuario/';
  private pathControlAcceso: string = '/controlAcceso/';
  private pathVerificaUsuario: string = '/verificaUsuario/';
  private pathVerificaCarnet: string = '/validacionCarnet/';
  private pathConfirmarAltaUsuario: string = '/confirmarAltaUsuario/';
  private pathDownloadMail: string = '/correoEnvio/descargaPkpass/';
  private pathSendEmailPending: string = '/correoEnvio/CorreoConfirmacion/';
  private pathDownloadPkpass: string = '/descargar/';

  private headers = new HttpHeaders().set('usuario', 'CUDI_APP')
      .set('clave', '83x6LOxkwzVe')
      .set('apikey', 'Q1VESV9BUFA6ODN4NkxPeGt3elZl')
      .set('Authorization', 'Basic Q1VESV9BUFA6ODN4NkxPeGt3elZl');

  private url: string = this._apiService.server+this.path;
  private urlCarnet: string = this._apiService.server+this.pathCarnet;

  /**
   * Devuelve información sobre el usuario especificado.
   * @returns
   */
   getUser(cdNifNie:String, cdMailUniversidad:String):Observable<any> {
    return this._apiService.postSinBody(this.url+this.pathUser+cdNifNie+"/"+cdMailUniversidad);
  }

  /**
   * Crea un usuario.
   * @param user Usuario a crear.
   */
  createUser(user:User): Observable<any> {
    return this._apiService.post(this.url+this.pathCreate, user);

  }

  /**
   * Modifica a un usuario.
   * @param user Usuario a modificar.
   */
   updateUser(user:User): Observable<any> {
    return this._apiService.post(this.url+this.pathUpdate, user);

  }

  /**
   * Modifica a un usuario.
   * @param user Usuario a modificar.
   */
   downloadMail(user:User): Observable<any> {
    return this._apiService.post(this.url+this.pathDownloadMail, user);

  }

  /**
   * Envía un email de confirmación de alta a un usuario.
   * @param user
   */
  sendPendingEmail(cdNifNie:String, cdMailUniversidad:String): Observable<any> {
    let urlEmail = this.pathSendEmailPending+cdNifNie+"/"+cdMailUniversidad;
    return this._apiService.postSinBody(this.url+urlEmail);
  }

  /**
   * Da de baja a un usuario.
   * @param idUser id del usuario a dar de baja.
   */
  bajaUser(idUser):Observable<any> {
    return this._apiService.postSinBody(this.url+this.pathBaja+idUser);
  }

  /**
   * Comprueba si el usuario especificado existe.
   * @returns User si existe.
   */
  checkUser(cdNifNie:String, cdMailUniversidad:String):Observable<any> {
      return this._apiService.postSinBody(this.url+this.pathControlAcceso+cdNifNie+"/"+cdMailUniversidad);
  }

  /**
   * Verificación del usuario.
   * @param cdNifNie Nif/Pasaporte del usuario
   * @param cdMailUniversidad Correo institucional
   * @returns
   */
  verificaUsuario(cdNifNie:String, cdMailUniversidad:String):Observable<any> {
    return this._apiService.postSinBody(this.url+this.pathVerificaUsuario+cdNifNie+"/"+cdMailUniversidad);
  }

  /**
   * Verificación del carnet
   * @param cdNifNie Nif/Pasaporte del usuario
   * @param cdMailUniversidad Correo institucional
   * @returns
   */
  verificarCarnet(cdNifNie:String, cdMailUniversidad:String):Observable<any> {
    return this._apiService.postSinBody(this.url+this.pathVerificaCarnet+cdNifNie+"/"+cdMailUniversidad);
  }

  confirmAccess(idUsuario:String):Observable<any> {
    return this._apiService.postSinBody(this.url+this.pathConfirmarAltaUsuario+idUsuario);
  }



  downloadFile(cdNifNie:String, cdMailUniversidad:String):Observable<any>{

    const baseUrl = this.urlCarnet+this.pathDownloadPkpass+cdNifNie+"/"+cdMailUniversidad;
    const headers = new HttpHeaders().set('usuario', 'CUDI_APP')
    .set('clave', '83x6LOxkwzVe')
    .set('apikey', environment.apiKey)
    .set('mv-hide-error', 'true')
    .set('Authorization', 'Basic ' + environment.apiKey);

    return this.http.get<any>(baseUrl, {headers, responseType: 'blob' as 'json'}).pipe(catchError(this._apiService.parseErrorBlob));
}

}
